var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: { d: "M5.02148 19H55.0215V52H5.02148V19Z", fill: "#179E7E" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M22.7405 26.5107L25.0825 29.7535L18.2498 34.6881L25.0825 39.6228L22.7405 42.8656L11.418 34.6881L22.7405 26.5107Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M22.6504 44.2703V25.1064L25.9284 29.3931V40.9923L22.6504 44.2703Z",
          fill: "#179E7E"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M37.3024 26.5107L34.9605 29.7535L41.7931 34.6881L34.9605 39.6228L37.3024 42.8656L48.625 34.6881L37.3024 26.5107Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M37.3926 44.2703V25.1064L34.1146 29.3931V40.9923L37.3926 44.2703Z",
          fill: "#179E7E"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M25.1504 45.5781L33.5879 23.6406L35.4546 24.3586L27.0171 46.2961L25.1504 45.5781Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M8.64648 31.875H13.709V38.625H8.64648V31.875Z",
          fill: "#179E7E"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M46.334 31.875H51.3965V38.625H46.334V31.875Z",
          fill: "#179E7E"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M5.02148 9H55.0215V19H5.02148V9Z", fill: "black" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M8.02148 12H12.0215V16H8.02148V12Z", fill: "#E1503C" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }